import { CurrencyEnum, LocaleEnum, cents, centsToUnits } from '@systemeio/ui'
import { ChartOptions } from 'chart.js'
import { currencyFormat } from 'shared/utils/currency-format'

export const getAffiliateChartOptions = (
  showGrid: boolean,
  selectedCurrency?: CurrencyEnum,
  locale?: LocaleEnum,
): ChartOptions<'bar'> => ({
  maintainAspectRatio: false,
  responsive: true,
  font: { family: 'Averta' },
  plugins: {
    legend: {
      display: true,
    },
  },
  scales: {
    y: {
      display: showGrid,
      border: { dash: [12, 12], display: false },
      grid: {
        color: function (context) {
          if (context.tick.value === 0) {
            return 'rgba(0, 0, 0, 0)'
          }
          return 'rgb(155 169 179 / 0.3)'
        },
        drawTicks: false,
      },
      ticks: {
        color: '#142D63',
        callback: function (value) {
          if (!selectedCurrency) return value
          return currencyFormat(centsToUnits(cents(value)), selectedCurrency, locale, true)
        },
      },
    },
    x: { grid: { display: false }, ticks: { color: '#142D63' } },
  },
})
